import React from 'react'

import {Participant} from '../types' 

import {Button, Icon, Grid, Divider} from 'semantic-ui-react'


const PlayerField = (props:{
    player:Participant,
    removePlayer: (number:number) => void,
    updatePlayerName: (name:string, player:Participant) => void,
    autoFocus?: boolean,
    formHasError:boolean,
    setFormHasError: (status:boolean) => void
    }) => {
    const error = props.formHasError && props.player.Name.length < 1;

    const onFocusEvent = () => {
        if(error){
            props.setFormHasError(false);
        }
    }

    return(
        <>
        <Grid >
            <Grid.Column width={2}>
                {props.player.Number}
            </Grid.Column>
            <Grid.Column width={12}>
            <input style={{margin:0}}
                onChange={(e) => props.updatePlayerName(e.target.value, props.player)}
                value={props.player.Name}
                autoFocus={props.autoFocus}
                maxLength={22}
                className={(error ? 'error' : '')}
                onFocus={() => onFocusEvent()}
            ></input>
            </Grid.Column>
            <Grid.Column width={2}>
                <Button tabIndex="-1" onClick={() => props.removePlayer(props.player.Number)} basic icon className="melee"><Icon name='remove circle'/></Button>
            </Grid.Column>
        </Grid>
        <Divider />
        </>
    )

}


export default PlayerField;
